<template>
  <div id="awardsContainer" class="page-container">
    <div class="page-content">
      <div class="flex-row-center mt-16">
        <img class="icon-pages" src="../assets/images/round-star-32dp.png" />
        <span class="page-title">{{ $t('page.awards') }}</span>
        <span class="page-des ml-16">{{ $t('page.awardsDescription') }}</span>
      </div>
       <el-tabs class="style-bar" v-model="activeName" @tab-click="forceRerender">
        <el-tab-pane name="status" default>
          <span slot="label" class="title-bar">{{ $t('page.status') }}</span>
          <status></status>
        </el-tab-pane>
        <el-tab-pane name="timeline">
          <span slot="label" class="title-bar">{{ $t('page.timeLine') }}</span>
          <timeline></timeline>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: "awards",
  components: {
    status: require("./awards/status").default,
    timeline: require("./awards/timeline").default,
  },
  data() {
    return {
      activeName: "status",
      anchor: {
        status: "status",
        timeline: "timeline",
      },
    };
  },
  watch: {
    activeName() {
      if (this.activeName != "") {
        const tab = this.activeName || "";
        const paramsTab = this.$router.currentRoute.params.tab;
        if (paramsTab != tab) {
          this.$router.push({ name: "awards", params: { tab } });
        }
      }
    }
  },
  mounted() {
    const params = this.$router.currentRoute.params.tab;
    if (params && this.anchor[params]) {
      this.activeName = params;
    } else {
      this.$router.push({ name: 'awards', params: { tab: "status" } })
    }
  },
  methods: {
    tabChange(tab) {
      this.activeName = tab;
    },
    forceRerender() {
      this.$router.push({ hash: this.activeName });
    }
  }
};
</script>

<style lang="scss" scoped>
.styleTab {
  margin-top: 32px;
  border: 1px solid #e0e0e0;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background: #ffffff;
}
</style>
<style lang="scss">
#awardsContainer .el-tabs__item {
  height: 52px;
  line-height: 52px;
  width: 150px;
  text-align: center;
}
#awardsContainer .el-tabs__header {
  margin: 0px;
}
</style>
